import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class JwtService {
  getToken(): string {
    //return window.localStorage.jwtToken;
    return window.localStorage.access_token;
  }

  saveToken(token: string) {
    //window.localStorage.jwtToken = token;
    window.localStorage.access_token = token;
  }

  destroyToken() {
    //window.localStorage.removeItem('jwtToken');
    window.localStorage.removeItem('access_token');
  }
}
